const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/pages/ErrorPage/ErrorPageLayout.tsx';
import { useCSSClasses } from './styles';
import { ReactNode } from 'react';

interface IErroPageLayoutProps {
    icon: ReactNode;
    header: ReactNode;
    summary: ReactNode;
    errorInformation?: ReactNode;
    restartBtn?: ReactNode;
}

export const ErrorPageLayout = (props: IErroPageLayoutProps) => {
    const classes = useCSSClasses();

    const mainMessage = (
        <div className={classes.mainMessage}>
            {props.header}
            {props.summary}
            {props.errorInformation}
        </div>
    );

    return (
        <div className={classes.page}>
            <div className={classes.mainContent}>
                <div className={classes.icon}>{props.icon}</div>
                {mainMessage}
            </div>
            {props.restartBtn && <div className={classes.button}>{props.restartBtn}</div>}
        </div>
    );
};
